import { render, staticRenderFns } from "./WechatManage.vue?vue&type=template&id=02ba1068&"
import script from "./WechatManage.vue?vue&type=script&lang=js&"
export * from "./WechatManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports